// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"9fb1c0ee","453":"9634f05b","455":"041d9f36","977":"23e7bc35"}[chunkId] + ".chunk.js";
};